import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { AddressInput } from 'components/forms';
import { FormValues } from '../CreditCardForm';
import { Checkbox, Field, Label } from '@quickmd-llc/design-system';

export default function BillingAddressForm(): JSX.Element {
  const { watch, control, clearErrors } = useFormContext<FormValues>();
  const sameAsHomeAddress = watch('sameAsHomeAddress');

  useEffect(() => {
    if (sameAsHomeAddress) {
      clearErrors('address');
    }
  }, [sameAsHomeAddress, clearErrors]);

  return (
    <div className="mt-3">
      <Field>
        <Label>Billing address</Label>
        <div className="my-2 flex items-center">
          <Controller
            control={control}
            defaultValue={true}
            name="sameAsHomeAddress"
            render={({ field: { onChange, value } }) => (
              <Checkbox onChange={onChange} checked={value} />
            )}
          />

          <div>
            <Label className="text-xs font-semibold text-text-dark">
              Same as home address
            </Label>{' '}
          </div>
        </div>
      </Field>

      {!sameAsHomeAddress && <AddressInput title="Enter billing address" />}
    </div>
  );
}
